export default __webpack_public_path__ + "static/media/871.ed4b34e9.gif";